import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import openIntercom from "../utils/open-intercom";

import $ from "jquery";
class CommonQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.onLivePopup = this.onLivePopup.bind(this);
  }

  componentDidMount() {
    $(".pricing-enterprise-cta", this.CommonQuestionsRef).on("click", (e) => {
      e.preventDefault();
      // $('.btn-nav-call').trigger('click');
    });
  }

  onLivePopup() {
    openIntercom();
  }

  render() {
    const {
      block: { config, content },
    } = this.props;

    const className = config && config.classNames ? config.classNames : "";
    const questions = [...content.items];
    const rows = [];

    while (questions.length > 0) {
      rows.push(questions.splice(0, 2));
    }

    return (
      <div ref={(el) => (this.CommonQuestionsRef = el)} className={className}>
        <div className='container u-widerContainer'>
          <div className='row'>
            <h2 className='CommonQuestions-title'>{content.title}</h2>
          </div>

          {rows.map((q, k) => {
            return (
              <div key={k} className='CommonQuestions-row'>
                {q.map((quest, key) => {
                  return (
                    <div
                      key={key}
                      className={classNames(
                        "CommonQuestions-item",
                        "col-xs-12 col-sm-5",
                        {
                          "col-sm-offset-1": key % 2 === 0,
                        }
                      )}
                    >
                      <h6>{quest.title}</h6>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: quest.description,
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
          <div className='CommonQuestions-row'>
            <div className='col-xs-12'>
              <p className='u-textCenter u-vSpacingMD-bottom'>
                Is there something else you&rsquo;re not clear on?{" "}
                <a onClick={this.onLivePopup} className='livechat-popper'>
                  Send us a message
                </a>{" "}
                and we&rsquo;ll come back to you as soon as we&rsquo;ve got the
                answer.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CommonQuestions.propTypes = {
  block: PropTypes.shape({
    config: PropTypes.shape({
      classNames: PropTypes.string,
    }),
    content: PropTypes.shape({}),
  }),
};

export default CommonQuestions;
